import * as Constants from 'client/util/Constants';
import { get } from 'lodash';
import { mapState } from 'vuex';
import EventMetadata, { eventFields } from 'client/Insights/ActivityLog/constants/EventMetadata';
import InsightsEventsApi from 'client/api/v2/InsightsEventsApi';
import moment from 'moment';

const { ItemTypeConsts, StoreModuleMap } = Constants;
const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

export default {
  computed: {
    ...mapState(settingsModule, ['features']),

    directoryInsightsPremium() {
      return get(this.features, 'directoryInsightsPremium.enabled', false);
    },

    firstDateInsightsAvailable() {
      // Customers get data 90 days max. Free accounts are restricted to 15 days of data.
      const numDays = this.directoryInsightsPremium ? 90 : 15;
      return new Date(moment().subtract(numDays, 'day').toDate());
    },
  },

  methods: {
    getLastEvent(eventTypes, additionalFilters = []) {
      if (!eventTypes) {
        throw new Error('Event type(s) required');
      }

      return InsightsEventsApi.fetch({
        end_time: new Date(),
        limit: 1,
        search_term: {
          and: [
            { [EventMetadata[eventFields.eventType].path]: eventTypes },
            ...additionalFilters,
          ],
        },
        service: ['all'],
        sort: 'DESC',
        start_time: this.firstDateInsightsAvailable,
      })
        .then(response => get(response, 'data.0', null));
    },

    getLastEventsList(limit, services = ['all'], additionalFilters = []) {
      const request = {
        end_time: new Date(),
        limit,
        service: services,
        sort: 'DESC',
        start_time: this.firstDateInsightsAvailable,
      };

      if (additionalFilters?.length) {
        request.search_term = {
          and: [
            ...additionalFilters,
          ],
        };
      }

      return InsightsEventsApi.fetch(request);
    },
  },
};
